import { Observation, QuestionnaireResponse } from "@medplum/fhirtypes";

import { Button, Group, Stack, Text, Title } from "@mantine/core";

import { getEditedByReference } from "@/encounters/components/EncounterLabor/services/labor";
import { longUSDateTimeFormat } from "@/utils/datetime";

interface LaborVersionDiffHeaderProps {
  observation?: Observation;
  questionnaireResponse?: QuestionnaireResponse;
  onExitAmendmentView?: () => void;
}

const LaborVersionDiffHeader = ({
  observation,
  questionnaireResponse,
  onExitAmendmentView,
}: LaborVersionDiffHeaderProps) => {
  // Use observation data if available, otherwise fall back to questionnaire response
  const effectiveDateTime = observation?.effectiveDateTime || questionnaireResponse?.authored;
  const issued = observation?.issued || questionnaireResponse?.authored;
  const editedByReference = observation
    ? getEditedByReference(observation)
    : questionnaireResponse?.meta?.author?.display;

  return (
    <Stack gap="xs">
      <Group wrap="wrap" align="flex-start" justify="space-between">
        <Title order={2}>Labor & Delivery Version Diff</Title>
        {onExitAmendmentView ? (
          <Button
            variant="outline"
            onClick={onExitAmendmentView}
            data-testid="labor-version-diff-exit-amendment-view-header"
          >
            Exit Amendment View
          </Button>
        ) : null}
      </Group>
      <Group gap="xl">
        {effectiveDateTime && (
          <Stack gap={0}>
            <Text size="sm" c="dimmed">
              {observation ? "Effective Date/Time" : "Authored Date/Time"}
            </Text>
            <Text>{longUSDateTimeFormat(effectiveDateTime)}</Text>
          </Stack>
        )}
        {issued && issued !== effectiveDateTime && (
          <Stack gap={0}>
            <Text size="sm" c="dimmed">
              Issued
            </Text>
            <Text>{longUSDateTimeFormat(issued)}</Text>
          </Stack>
        )}
        {editedByReference && (
          <Stack gap={0}>
            <Text size="sm" c="dimmed">
              Edited By
            </Text>
            <Text>{editedByReference}</Text>
          </Stack>
        )}
      </Group>
    </Stack>
  );
};

export default LaborVersionDiffHeader;
